import { PublicClientApplication, InteractionRequiredAuthError } from '@azure/msal-browser';
import { apiTokenRequest, msalConfig } from '../authConfig';

export const msalInstance = new PublicClientApplication(msalConfig);

export const acquireApiAccessToken = async (
    instance: PublicClientApplication,
    forceRefresh = false,
): Promise<string | null> => {
    if (!instance.getActiveAccount()) {
        const accounts = instance.getAllAccounts();
        if (accounts.length > 0) {
            instance.setActiveAccount(accounts[0]);
        }
    }

    const account = instance.getActiveAccount() || instance.getAllAccounts()[0];

    if (!account) {
        console.warn("No account available for token acquisition");
        return null;
    }

    const request = {
        scopes: apiTokenRequest.scopes,
        account: account,
        forceRefresh
    };

    try {
        const response = await instance.acquireTokenSilent(request);
        return response.accessToken;
    } catch (error) {
        if (error instanceof InteractionRequiredAuthError) {
            console.warn("Interaction required for token acquisition", error);
        } else {
            console.error("Silent token acquisition failed", error);
        }
        return null;
    }
};

export const getAccessToken = (forceRefresh = false): Promise<string | null> =>
    acquireApiAccessToken(msalInstance, forceRefresh);

export const logout = () => {
    msalInstance.logoutRedirect();
};

let atlasLogoutStarted = false;

export const logoutForAtlasAccessDenied = async (): Promise<void> => {
    if (atlasLogoutStarted) {
        return;
    }

    atlasLogoutStarted = true;
    try {
        await msalInstance.logoutRedirect({
            postLogoutRedirectUri: window.location.origin,
        });
    } finally {
        atlasLogoutStarted = false;
    }
};
